/**
 * 监听器
 */

class Observe {
  constructor() {
    this.listener = {};
  }

  on(event, fn) {
    if (typeof this.listener[event] === 'undefined') {
      this.listener[event] = [fn];
    } else {
      this.listener[event].push(fn);
    }
  }

  off(event, fn) {
    if (this.listener[event] instanceof Array) {
      for (let i = 0; i < this.listener[event].length; i++) {
        if (this.listener[event][i] === fn) {
          this.listener[event].splice(i, 1);
        }
      }
    }
  }

  // 发布消息
  publish(event, params) {
    if (this.listener[event] instanceof Array) {
      for (let i = 0; i < this.listener[event].length; i++) {
        this.listener[event][i](params);
      }
    }
  }
}

export default Observe;
